module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/hall-list/plan-ceremony-lineup-kyushu-4-94c51f67b9c41d75e9d9040c80d41419.png";